import { render, staticRenderFns } from "./BadgesCreateForm.vue?vue&type=template&id=405b3700&"
import script from "./BadgesCreateForm.vue?vue&type=script&lang=js&"
export * from "./BadgesCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports